<template>
  <div class="kpt-configurator-total-wrapper">
    <div class="configurator-total-box">
      <div class="configurator-total-header">
        <div></div>
        <div v-if="wholesale" class="is-uppercase">Wholesale</div>
        <div class="is-uppercase">
          <span v-if="wholesale">MSRP</span>
          <span v-else>Retail</span>
        </div>
      </div>
      <div class="configurator-total-content" >
        <div>
          <h5 class="has-text-black-ter has-text-bold"><strong>Estimated Cost:</strong></h5>
        </div>
        <h6 v-if="wholesale">
          <h5>{{$numeral(wholesaleTotal).format('$0,0')}}</h5>
        </h6>
        <h6>
          <h5>{{$numeral(msrpTotal).format('$0,0')}}</h5>
        </h6>
      </div>
      <div class="configurator-total-content mt-2" v-if="showMonthly">
        <div>
          <h5 class="has-text-black-ter has-text-bold"><strong>Estimated Monthly:</strong></h5>
        </div>
        <template v-if="!isCustom">
          <h6 v-if="wholesale">
            <h5>{{$numeral(wholesaleMonthly).format('$0,0')}}</h5>
          </h6>
          <h6>
            <h5>{{$numeral(msrpMonthly).format('$0,0')}}</h5>
          </h6>
        </template>
        <template v-else>
          <h6 v-if="wholesale">
            <h5>TBD</h5>
          </h6>
          <h6>
            <h5>TBD</h5>
          </h6>
        </template>
      </div>
      <font-awesome-icon class="configurator-total-expand" :icon="['far', 'chevron-up']" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    msrpTotal: Number,
    msrpMonthly: Number,
    wholesaleTotal: Number,
    wholesaleMonthly: Number,
    wholesale: Boolean,
    showMonthly: Boolean,
    isCustom: Boolean
  }
}
</script>
<style lang="scss" scoped>
.kpt-configurator-total-wrapper {
  position: absolute;
  bottom: 0;
  margin-left: -1rem;
  width: 100%;
  display: flex;
  justify-content: center;

  .configurator-total-box {
    background: white;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    padding: 1rem 1.5rem 1.5rem;
    width: 55%;
    position: relative;

    &:hover { cursor: pointer; }

    @media screen and (max-width: 1025px) {
      width: 95%;
    }

    .configurator-total-header {
      display: grid;
      grid-template-columns: 175px 1fr 1fr;
      align-items: center;
      font-size: 0.75rem;
    }

    .configurator-total-content {
      display: grid;
      grid-template-columns: 175px 1fr 1fr;
      align-items: center;

      h6 {
        small {
          text-transform: uppercase;
        }
      }

      h5 {
        display: block;
        margin-bottom: 0;
      }
    }

    .configurator-total-expand {
      position: absolute;
      right: 0.6rem;
      top: 0.5rem;
    }
  }
}
</style>
